import React from "react";
import ReactDOM from "react-dom/client";
import {Amplify} from "aws-amplify";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {Provider} from "react-redux";
import {ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import {App} from "./App";
import {loadAmplifyConfig} from "./config/loadAmplifyConfig";
import {store} from "./store/store";
import {adminTheme} from "./theme/theme";
import i18n from "./i18n";
import {AuthCard, ErrorDetails} from "./components/ui/AuthCard";
import "./index.css";
import "@aws-amplify/ui-react/styles.css";

async function bootstrap() {
    const cfg = await loadAmplifyConfig();
    if (!cfg || Object.keys(cfg).length === 0) {
        throw new Error(
                "Missing Amplify configuration. Load from /assets/aws-exports.json (deployed in production; for local dev put the file in public/assets/aws-exports.json).",
        );
    }
    Amplify.configure(cfg);
}

// A data router, so pages can block navigation while they hold unsaved edits; App declares the routes.
const router = createBrowserRouter([{path: "*", element: <App />}]);

bootstrap()
        .then(() => {
            ReactDOM.createRoot(document.getElementById("root")!).render(
                    <React.StrictMode>
                        <ThemeProvider theme={adminTheme}>
                            <CssBaseline />
                            <Provider store={store}>
                                <RouterProvider router={router} />
                            </Provider>
                        </ThemeProvider>
                    </React.StrictMode>,
            );
        })
        .catch((e: unknown) => {
            const msg = e instanceof Error ? e.message : String(e);
            ReactDOM.createRoot(document.getElementById("root")!).render(
                    <ThemeProvider theme={adminTheme}>
                        <CssBaseline />
                        <AuthCard title={i18n.t("STARTUP_ERROR_TITLE")} explanation={i18n.t("STARTUP_ERROR_EXPLANATION")}>
                            <ErrorDetails title={i18n.t("STARTUP_ERROR_DETAILS")} details={msg} />
                        </AuthCard>
                    </ThemeProvider>,
            );
        });
